<template>
  <div class="mask" @click.self="closeRule">
    <div class="draw-rule" role="dialog" aria-modal="true" aria-labelledby="draw-rule-title">
      <div class="panel">
        <div class="title">
          <h2 id="draw-rule-title">{{ controlInfo.popupTitle }}</h2>
        </div>
        <div class="content">
          <div class="text" v-html="controlInfo.ruleContent"></div>
        </div>
      </div>

      <button class="close" type="button" aria-label="Close" @click="closeRule"></button>
    </div>
  </div>
</template>
<script setup>
  import {onBeforeUnmount, onMounted} from 'vue'

  const emit = defineEmits(['closeRule'])
  defineProps({
    controlInfo: {
      type: Object,
      default: () => ({})
    }
  })
  const closeRule = () => {
    emit('closeRule')
  }

  let previousBodyOverflow = ''

  onMounted(() => {
    previousBodyOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  })

  onBeforeUnmount(() => {
    document.body.style.overflow = previousBodyOverflow
  })
</script>
<style scoped lang="scss">
$panel: #fff6e8;
$border: #ffc9c5;
$card: #ffdda2;
$red: #d52212;

.mask {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
  background: rgba(20, 9, 3, 0.72);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.draw-rule {
  width: min(760px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  position: relative;
  padding-top: 20px;
  color: $red;
  font-family: Arial, Helvetica, sans-serif;

  .panel {
    width: 100%;
    max-height: calc(100vh - 68px);
    display: flex;
    flex-direction: column;
    padding: 52px 24px 24px;
    overflow: hidden;
    border: 4px solid $border;
    border-radius: 32px;
    background: $panel;
    box-shadow: 0 22px 64px rgba(89, 29, 5, 0.34);
  }

  .title {
    width: min(343px, 52%);
    aspect-ratio: 343 / 84;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 34px;
    background: url("@/assets/frame/btn-bgk.png") center / 100% 100% no-repeat;
    transform: translateX(-50%);

    h2 {
      width: 100%;
      margin: 0;
      overflow: hidden;
      color: #fff;
      font-size: clamp(20px, 1.4583vw, 28px);
      line-height: 1.15;
      font-weight: 700;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .content {
    min-height: 0;
    overflow: hidden;
    border-radius: 20px;
    background: $card;
  }

  .text {
    max-height: min(60vh, 540px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 26px;
    color: #a82b18;
    font-size: 17px;
    line-height: 1.75;
    font-weight: 400;
    text-align: left;
    overflow-wrap: anywhere;
    scrollbar-width: thin;
    scrollbar-color: #ff8a1e transparent;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 999px;
      background: #ff8a1e;
    }
  }

  .close {
    width: 34px;
    height: 34px;
    position: absolute;
    top: 36px;
    right: 20px;
    z-index: 5;
    border: 0;
    border-radius: 50%;
    background: #ff6b1a;
    box-shadow: 0 4px 10px rgba(151, 54, 4, 0.22);
    cursor: pointer;

    &::before,
    &::after {
      content: "";
      width: 16px;
      height: 2px;
      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 2px;
      background: #fff;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:focus-visible {
      outline: 3px solid #ffb24a;
      outline-offset: 2px;
    }
  }
}

:deep(.text > :first-child) {
  margin-top: 0;
}

:deep(.text > :last-child) {
  margin-bottom: 0;
}

:deep(.text *) {
  color: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
}

:deep(.text p) {
  margin: 0 0 1em;
}

:deep(.text img) {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 14px auto;
  border-radius: 14px;
}

@media screen and (max-width: 768px) {
  .mask {
    padding: 12px;
  }

  .draw-rule {
    width: min(343px, calc(100vw - 24px));
    max-height: calc(100vh - 24px);
    padding-top: 14px;

    .panel {
      max-height: calc(100vh - 38px);
      padding: 44px 14px 16px;
      border-width: 3px;
      border-radius: 24px;
    }

    .title {
      width: 210px;
      padding: 0 22px;

      h2 {
        font-size: 18px;
      }
    }

    .content {
      border-radius: 16px;
    }

    .text {
      max-height: min(62vh, 430px);
      padding: 16px;
      font-size: 14px;
      line-height: 1.65;
    }

    .close {
      width: 28px;
      height: 28px;
      top: 28px;
      right: 12px;

      &::before,
      &::after {
        width: 13px;
      }
    }
  }
}
</style>
